module.exports = __webpack_public_path__ + "media/vsr_bg1.46d82444.mp3";